import { HttpService } from "../HttpService";
import { URL } from "enum";
const URL_API = URL.BASE;

const RendimientoService = {

	async listar() {
		const respuesta = await HttpService(URL_API).get("/portal-colaborador/comunicaciones-cultura/rendimiento");
		return respuesta.data;
	}

};
export default RendimientoService;
